import React from 'react';
import { Section } from './ui/Section';
export function ComparisonTable() {
  const rows = [{
    without: 'Improvisas cada clase',
    cost: '3 horas semanales perdidas',
    with: 'Clase lista en 10 minutos'
  }, {
    without: 'Alumnos que se van sin avisar',
    cost: '1 alumno = 40€/mes menos',
    with: 'Sistema de retención 90 días'
  }, {
    without: 'Siempre las mismas figuras',
    cost: 'Alumnos aburridos que se van',
    with: '+40 figuras clasificadas por nivel'
  }, {
    without: 'No sabes enseñar sensual',
    cost: 'Pierdes alumnos avanzados',
    with: 'Protocolo claro sin incomodidad'
  }, {
    without: 'Buen bailarín, mal instructor',
    cost: 'Sin autoridad en sala',
    with: 'Instructor de referencia en tu ciudad'
  }];
  return <Section data-id="element-89">
      <h2 className="font-display text-3xl md:text-4xl font-bold text-center mb-8 text-brand-title" data-id="element-90">
        ❌ vs ✅
      </h2>

      <div className="overflow-x-auto" data-id="element-91">
        <div className="text-center text-sm text-brand-textMuted mb-4 md:hidden tracking-wide" data-id="element-92">
          ← Scroll to see full table →
        </div>
        <table className="w-full min-w-[800px] border-collapse bg-gradient-card rounded-2xl overflow-hidden shadow-card border border-brand-border" data-id="element-93">
          <thead data-id="element-94">
            <tr className="bg-brand-card/50 border-b border-brand-borderGlow/20" data-id="element-95">
              <th className="text-left p-4 text-brand-textMuted font-heading font-semibold tracking-wide uppercase text-sm" data-id="element-96">
                ❌ Sin el Manual
              </th>
              <th className="text-left p-4 text-orange-400 font-heading font-semibold tracking-wide uppercase text-sm" data-id="element-97">
                💸 Lo que te cuesta
              </th>
              <th className="text-left p-4 text-brand-title font-heading font-bold tracking-wide uppercase text-sm" data-id="element-98">
                ✅ Con el Manual
              </th>
            </tr>
          </thead>
          <tbody data-id="element-99">
            {rows.map((row, i) => <tr key={i} className="hover:bg-brand-card/30 transition-colors border-b border-brand-border/30 last:border-0" data-id="element-100">
                <td className="p-4 text-brand-text font-body" data-id="element-101">{row.without}</td>
                <td className="p-4 text-orange-300 font-body font-semibold" data-id="element-102">
                  {row.cost}
                </td>
                <td className="p-4 text-brand-subtitle font-body font-semibold" data-id="element-103">
                  {row.with}
                </td>
              </tr>)}
          </tbody>
        </table>
      </div>

      <div className="bg-gradient-card border border-brand-gold/30 rounded-2xl p-6 max-w-3xl mx-auto text-center mt-8 shadow-gold-glow" data-id="element-104">
        <p className="text-brand-text text-lg leading-relaxed" data-id="element-105">
          ¿Cuánto te cuesta al mes no tener este sistema? Solo un alumno que se
          da de baja son 40€ menos.
        </p>
        <p className="text-brand-gold text-xl font-bold mt-2" data-id="element-106">
          Este manual cuesta 13,99€. Las matemáticas son fáciles.
        </p>
      </div>
    </Section>;
}